module.exports = __webpack_public_path__ + "static/media/banner_SPclients.fcbf4798.png";